import React, { useContext, useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { httpReauest } from "../../utils/httpRequest";
import { CDN_BASE_URL } from "../../config";
import { ProductContext } from "../../context/ProductContext";

const Header = ({ dealerData }) => {
  const [show, setShow] = useState(false);
  const [category, setcategory] = useState([]);
  const [urls, seturls] = useState([]);
  const [brands, setbrands] = useState([]);
  const [selectcategory, setselectcategory] = useState();
  const [selectedbrand, setselectedbrand] = useState();

  const { setselectProduct, selectProduct } = useContext(ProductContext);

  useEffect(() => {
    getData();
  }, []);

  async function getData() {
    await httpReauest("GET", "/category/header", {}, {}).then(({ data }) => {
      setcategory(data?.data.categories);
      seturls(data?.data.urls);
      setbrands(data?.data.brands);
    });
  }

  return (
    <>
      {show && (
        <div
          onClick={() => setShow(false)}
          className="fixed left-0 top-0 w-full h-full bg-[#00000050] z-30"
        ></div>
      )}
      <div className=" h-[95px] relative ">
        <div className=" w-full left-0  z-40 bg-[#fff] fixed top-0 pt-3">
          <div className="container_1 w-full  flex justify-between items-center header-line mx-auto relative py-5">
            <div
              className={`${
                show ? "h-[75vh] p-7" : "h-0 p-0"
              } duration-500 w-full absolute  bg-white top-[100%] left-0 rounded-[10px] overflow-hidden`}
            >
              <div className="  relative h-full flex ">
                <span className="flex flex-col lg:w-[120px] w-[140px] pl-2 border-l border-black h-full overflow-y-scroll relative overflow-x-visible">
                  {category?.map((cat) => (
                    <>
                      <Link
                        onMouseEnter={() => {
                          setselectcategory(cat);
                          setselectedbrand(null);
                        }}
                        onClick={() => {
                          setShow(false);
                        }}
                        to={"/" + cat?.url}
                        className={`${
                          selectcategory?._id === cat?._id && "bg-[#ebebeb]"
                        } w-full p-4 hover_show_div duration-200 rounded-[10px]`}
                      >
                        <img
                          className="w-full mb-2"
                          src={CDN_BASE_URL + cat.img}
                          alt=""
                        />
                        <p className="text-center">{cat.name}</p>
                      </Link>
                    </>
                  ))}
                </span>
                {selectcategory && (
                  <span className="flex flex-col lg:w-[150px] xl:w-[170px] gap-2 border-l px-2 border-black h-full overflow-y-scroll relative overflow-x-visible">
                    {brands.map((brand) => {
                      if (brand?.category === selectcategory._id) {
                        return (
                          <>
                            <li
                              onMouseEnter={() =>
                                setselectedbrand(brand?.brand)
                              }
                              className={`${
                                selectedbrand?._id === brand?.brand?._id &&
                                "bg-[#ebebeb]"
                              } duration-200 font-[600] text-[18px] py-2 ps-3 hover_show_span relative rounded-[8px]`}
                            >
                              <Link
                                onClick={() => setShow(false)}
                                to={`/${selectcategory?.url}/${brand?.brand?.name}`}
                                className=""
                              >
                                {brand?.brand?.title}
                              </Link>{" "}
                            </li>
                          </>
                        );
                      }
                    })}
                  </span>
                )}
                {selectedbrand && (
                  <span className="flex-col flex flex-wrap gap-4  h-full  relative ">
                    {urls.map((item) => {
                      if (
                        item.brand.name === selectedbrand.name &&
                        item.category === selectcategory._id
                      ) {
                        return (
                          <>
                            <Link
                              onClick={() => {
                                setShow(false);
                                setselectProduct(null);
                              }}
                              className="font-[600] text-[17px] hover_show_span relative py-2 ps-5"
                              to={`/${selectcategory.url}/${selectedbrand.name}/${item?.name}`}
                            >
                              {item?.menu}
                            </Link>
                          </>
                        );
                      }
                    })}
                  </span>
                )}
                <span className="absolute left-0 top-0 w-[40%] h-full">
                  <img
                    src="/p1.png"
                    alt=""
                    className="w-full rounded-[10px] h-full object-cover"
                  />
                </span>
              </div>
            </div>
            <span className="flex gap-[1.4vw] items-center">
              <Link to={"/"} className="text-[12px] 2xl:text-[16px] font-[500]">
                صفحه اصلی
              </Link>
              <button
                onClick={() => setShow(!show)}
                to={"/"}
                className={`${
                  show && "btn-brand text-secendory "
                } font-[500] z-50 text-[14px] 2xl:text-[16px] duration-200`}
              >
                دسته بندی ها
              </button>
              <Link
                to={"/targeted-buy"}
                className="text-[12px] 2xl:text-[16px] font-[500]"
              >
                خرید هدفمند
              </Link>
              <Link
                to={"/pay-later"}
                className="text-[12px] 2xl:text-[16px] font-[500]"
              >
                خرید اقساطی
              </Link>
              <Link
                to={"/compare"}
                className="text-[12px] 2xl:text-[16px] font-[500]"
              >
                مقایسه
              </Link>
              <Link
                to={"/blogs"}
                className="text-[12px] 2xl:text-[16px] font-[500]"
              >
                اخبار و دانستنی ها
              </Link>
            </span>
            <Link to={"/"} className="logo-center">
              <img
                src="/logo_1924.svg"
                alt="لوگوی 1924"
                className="w-[140px]"
              />
              <span className="text-[10px] font-medium">
                مرکز خرید و فروش ماشین های سنگین
              </span>
            </Link>
            <span className="flex gap-[1.4vw] items-center">
              <Link
                to={"/brands"}
                className="text-[12px] 2xl:text-[16px] font-[500]"
              >
                برند ها
              </Link>
              <Link
                to={"/work-with-us"}
                className="text-[12px] 2xl:text-[16px] font-[500]"
              >
                همکاری با ما
              </Link>
              <Link
                to={"/about"}
                className="text-[12px] 2xl:text-[16px] font-[500]"
              >
                درباره ما
              </Link>
              <Link
                to={"/contact"}
                className="text-[12px] 2xl:text-[16px] font-[500]"
              >
                تماس با ما
              </Link>
              <Link to={"https://my.1924.ir"} className="btn-brand">
                ثبت آگهی
              </Link>
            </span>
          </div>
        </div>
      </div>
    </>
  );
};

export default Header;
